import featureToggles from '../services/feature-toggles';
import { ApplicationType, Application } from './constants/app';

export function isPcomSearchAvailable(locale: string, app: ApplicationType): boolean {
  const countryList = ['de-DE', 'en-US', 'en-CN', 'zh-CN'];
  return featureToggles.isPcomSearchToggleActive() && countryList.includes(locale) && app === Application.pcom;
}

export function getSearchLink(locale: string): string {
  switch (locale) {
    case 'de-DE':
      return 'https://www.porsche.com/germany/search/';
    case 'en-US':
      return 'https://www.porsche.com/usa/search/';
    case 'en-CN':
      return 'https://www.porsche.com/china/en/search/';
    case 'zh-CN':
      return 'https://www.porsche.com/china/zh/search/';
    default:
      return '';
  }
}
